import { render, staticRenderFns } from "./ZDTag.vue?vue&type=template&id=b2c0848a&"
import script from "./ZDTag.vue?vue&type=script&lang=js&"
export * from "./ZDTag.vue?vue&type=script&lang=js&"
import style0 from "./ZDTag.vue?vue&type=style&index=0&id=b2c0848a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports